/**
 * Open a blank tab synchronously, returning the handle to navigate later.
 *
 * Download buttons that need an async round-trip (signed-ticket mutation
 * or presigned-URL query) BEFORE the destination URL is known cannot call
 * `window.open(url, ...)` after that round-trip — the open happens
 * outside the original user-gesture window, which Chrome / Safari / etc.
 * treat as a programmatic popup and block — so the operator clicks,
 * gets a successful ticket back, and sees nothing. The fix is to open
 * `about:blank` synchronously in the click handler (still inside the
 * gesture-trust window), then `location.replace` it once the URL is
 * resolved — or close it if the resolution fails.
 *
 * Same pattern as `entities/procedures/pdf/shared.jsx#openPdf`.
 *
 * `tab.opener = null` is the manual equivalent of the `'noopener'`
 * feature flag — we can't pass that on the initial open because we
 * need the handle, but reverse-tabnabbing must still be blocked.
 */
export function openBlankTab(): Window | null {
  const tab = window.open('about:blank', '_blank');
  if (tab) tab.opener = null;
  return tab;
}
